export enum EmailAddressActionTypes {
  ADD_EMAIL_ADDRESS = "ADD_EMAIL_ADDRESS"
}
export enum AddressActionTypes {
  ADD_ADDRESS = "ADD_ADDRESS"
}
export enum PhoneActionTypes {
  ADD_PHONE = "ADD_PHONE"
}


export enum StartDateActionTypes {
  ADD_DATE = "ADD_DATE",
  RESET_DATE = "RESET_DATE"
}

export enum BasketActionTypes {
  ADD_TO_BASKET = "ADD_TO_BASKET",
  REMOVE_FROM_BASKET = "REMOVE_FROM_BASKET",
  UPDATE_BASKET = "UPDATE_BASKET",
  CLEAR_BASKET = "CLEAR_BASKET"
}

export enum PropertiesActionTypes {
  ADD_PROPERTY = "ADD_PROPERTY"
}

export enum PolicyActionTypes {
  CREATE_POLICY = "CREATE_POLICY",
  CREATE_POLICY_COMPLETED = "CREATE_POLICY_COMPLETED",
  CREATE_POLICY_FAILED = "CREATE_POLICY_FAILED",
  CLEAR_POLICY_RESPONSE = "CLEAR_POLICY_RESPONSE",
  FINALISE_POLICY = "FINALISE_POLICY",
  FINALISE_POLICY_COMPLETED = "FINALISE_POLICY_COMPLETED",
  FINALISE_POLICY_FAILED = "FINALISE_POLICY_FAILED"
}

export enum ProductsActionTypes {
  GET_PRODUCTS = "GET_PRODUCTS",
  GET_PRODUCTS_COMPLETED = "GET_PRODUCTS_COMPLETED",
  GET_PRODUCTS_FAILED = "GET_PRODUCTS_FAILED"
}

export enum AgentActionTypes {
  GET_LOGO = "GET_LOGO",
  GET_LOGO_COMPLETED = "GET_LOGO_COMPLETED"
}

export enum PaymentActionTypes {
  INITIATE_PAYMENT = "INITIATE_PAYMENT",
  PAYMENT_PROCESS_STARTED = "PAYMENT_PROCESS_STARTED",
  PAYMENT_PROCESS_FAILED = "PAYMENT_PROCESS_FAILED",
  CLEAR_PAYMENT_RESPONSE = "CLEAR_PAYMENT_RESPONSE"
}

export enum UserActionTypes {
  CHECK_RELATED_POLICIES = "CHECK_RELATED_POLICIES",
  GET_MINIMUM_START_DATE = "GET_MINIMUM_START_DATE"
}

export enum UtmActionTypes {
  SET_UTM = "SET_UTM",
  GET_UTM = "GET_UTM"
}
